import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { FaBook, FaGraduationCap, FaArrowRight } from 'react-icons/fa';

const Home = () => {
  const { t } = useLanguage();

  return (
    <div className="relative min-h-screen">
      {/* Hero Section */}
      <div className="absolute inset-0 bg-cover bg-center z-0" 
           style={{
             backgroundImage: "url('https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')",
             filter: "brightness(0.7)"
           }} 
      />
      
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-white text-center px-4">
        <motion.div 
          className="flex items-center space-x-4 mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img 
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1750973984906-Mascotte_testa_1_to_1.png" 
            alt="Cosmo Education Logo" 
            className="h-20 w-20 rounded-full" 
          />
          <h1 className="text-5xl md:text-6xl font-bold">
            {t('welcomeTitle')}
          </h1>
        </motion.div>
        
        <motion.p 
          className="text-xl md:text-2xl mb-8 max-w-2xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {t('welcomeSubtitle')}
        </motion.p>
        
        {/* CTA Buttons */}
        <motion.div 
          className="flex flex-col sm:flex-row gap-4 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <Link 
            to="/courses" 
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 flex items-center space-x-2"
          >
            <FaGraduationCap />
            <span>{t('premiumCourses')}</span>
          </Link>
          
          <Link 
            to="/free-resources" 
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 flex items-center space-x-2"
          >
            <FaBook />
            <span>{t('freeResources')}</span>
          </Link>
        </motion.div>
      </div>

      {/* Features Section */}
      <div className="relative z-10 bg-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('whatWeOffer')}</h2>
            <p className="text-xl text-gray-600">{t('comprehensiveLearning')}</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Premium Courses */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1, duration: 0.8 }}
              className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg p-8 shadow-lg"
            >
              <div className="flex items-center mb-4">
                <FaGraduationCap className="text-indigo-600 text-3xl mr-4" />
                <h3 className="text-2xl font-bold text-gray-900">{t('premiumCourses')}</h3>
              </div>
              <p className="text-gray-600 mb-6">{t('premiumCoursesDescription')}</p>
              <Link 
                to="/courses"
                className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-semibold"
              >
                {t('exploreCourses')} <FaArrowRight className="ml-2" />
              </Link>
            </motion.div>

            {/* Free Resources */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1.2, duration: 0.8 }}
              className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-8 shadow-lg"
            >
              <div className="flex items-center mb-4">
                <FaBook className="text-green-600 text-3xl mr-4" />
                <h3 className="text-2xl font-bold text-gray-900">{t('freeResources')}</h3>
              </div>
              <p className="text-gray-600 mb-6">{t('freeResourcesDescription')}</p>
              <Link 
                to="/free-resources"
                className="inline-flex items-center text-green-600 hover:text-green-800 font-semibold"
              >
                {t('accessResources')} <FaArrowRight className="ml-2" />
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;